
import { defineComponent } from 'vue';
import {mapActions, mapGetters} from 'vuex'
import UserService from "@/services/UserService";

export default defineComponent({
	name: 'ProfileComponent',
    computed: {
        ...mapGetters(["getUsername", "getLoggedStatus", "getUserPreloader"])
    },
    created() {
      this.checkLoggedStatus()
    },
    methods: {
        ...mapActions(["checkLoggedStatus"]),
        logout() : void {
          UserService.logout().then(() => {
            this.checkLoggedStatus()
            this.$router.go(0)
          })
        }
    }
})
